<template>
	<div class="mb-4" v-if="mutual">
		<v-form ref="form">
			<v-layout row wrap>
				<v-flex d-flex xs12>
					<v-card color="primary" dark>
						<v-card-text><h3>{{numberOfModules > 1 ?
								'Podział kosztów realizacji zadania pomiędzy oferentów modułu ' + moduleNumber :
								'Podział kosztów realizacji zadania pomiędzy oferentów'}}
							<span v-if="showPrintInfo" class="d-none print-only-inline"> (Wydruk próbny!)</span>
						</h3></v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
			<v-layout row wrap>
				<v-flex d-flex xs6>
					<v-card color="blue" class="white--text">
						<v-card-text><h3>Źródło finansowania kosztów</h3></v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs3>
					<v-card color="blue" class="white--text">
						<v-card-text><h3>Wartość</h3></v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs3>
					<v-card color="blue" class="white--text">
						<v-card-text><h3>Udział</h3></v-card-text>
					</v-card>
				</v-flex>
			</v-layout>

			<v-layout row wrap>
				<v-flex d-flex xs6>
					<v-card color="grey lighten-2">
						<v-card-text><strong><b> Suma wszystkich kosztów realizacji zadania</b></strong></v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs3>
					<v-card color="grey lighten-3">
						<v-card-text><strong> {{formatMoney(neededCosts)}} PLN</strong></v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs3>
					<v-card color="grey lighten-3">
						<v-card-text><strong> 100,00% </strong></v-card-text>
					</v-card>
				</v-flex>
			</v-layout>

			<v-layout row wrap v-for="(funding, index) in fundingsInternal" :key=index>
				<v-flex d-flex xs6>
					<v-card color="grey lighten-2">
						<v-card-text><strong>{{funding.polishName}}</strong></v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs3>
					<v-card color="grey lighten-3">
						<v-card-text v-if="!readonly">
							<strong>
								<egranty-number-input-field
									label="Wartość finansowania"
									for="bidder-fundings-table-funding-value"
									id="bidder-fundings-table-funding-value"
									v-model="funding.funding"
									@input="error = false"
								></egranty-number-input-field>
							</strong>
						</v-card-text>
						<v-card-text v-else>
							<strong>
								{{funding.funding === null ? '-' : formatMoney(funding.funding) + ' PLN'}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs3>
					<v-card color="grey lighten-3">
						<v-card-text><strong>{{percentages[index]}}%</strong></v-card-text>
					</v-card>
				</v-flex>
			</v-layout>

			<div v-if="error">
				<egranty-validation-error
					error="Podane kwoty nie sumują się do sumy wszystkich kosztów realizacji zadania!"/>
			</div>

			<div v-if="!isNaN(totalCostsFromInput) && neededCosts===totalCosts && !readonly">
				<v-layout row wrap>
					<v-flex d-flex xs12>
						<v-card color="green lighten-2">
							<v-card-text><strong>Podane kwoty są poprawne!</strong></v-card-text>
						</v-card>
					</v-flex>
				</v-layout>
			</div>
		</v-form>
	</div>
</template>

<script>
	import EgrantyNumberInputField from "../../../../genericComponents/EgrantyNumberInputField";
	import {Numbers} from "@/utils/Numbers";
	import EgrantyValidationError from "../../../../genericComponents/EgrantyValidationError";

	export default {
		name: "BidderFundingsTable",
		mixins: [Numbers],
		components: {EgrantyValidationError, EgrantyNumberInputField},
		data() {
			return {
				fundingsInternal: [],
				error: '',
			};
		},

		computed: {
			neededCosts() {
				let totalAdministrative = 0;
				let totalActions = 0;

        for (let action of this.actions) {
          for (let actionCost of action.costs) {
            let costValue = actionCost.pricePerUnit * actionCost.unitsCount;
            totalActions += isNaN(costValue) ? 0 : costValue;
          }
        }

        for (let administrativeCost of this.administrative) {
          let costValue = administrativeCost.pricePerUnit * administrativeCost.unitsCount;
          totalAdministrative += isNaN(costValue) ? 0 : costValue;
        }

        return (totalActions + totalAdministrative).toFixed(2);
			},

			percentages() {
				let res = [];
				let i = 0;
				for (var funding of this.fundingsInternal) {
					res[i] = Numbers.methods.formatPercentage(funding.funding, this.neededCosts);
					i++;
				}
				return res;
			},

			totalCosts() {
				let res = 0;
				for (var funding of this.fundingsInternal) {
					res += isNaN(parseFloat(funding.funding)) ? 0 : parseFloat(funding.funding);
				}
				return res.toFixed(2);
			},

			totalCostsFromInput() {
				let res = 0;
				for (var funding of this.fundingsInternal) {
					res += parseFloat(funding.funding);
					if (isNaN(parseFloat(funding.funding))) {
						return NaN;
					}
				}
				return res;
			},
		},

		methods: {
			validate() {
				let valid = true;
				valid &= this.$refs.form.validate();
				if (this.neededCosts !== this.totalCosts) {
					valid = false;
					this.error = true;
				}

				return valid;
			}
		},

		watch: {
			fundings: {
				immediate: true,
				deep: true,
				handler(val) {
					if (val === undefined) {
						return;
					}
					this.fundingsInternal = val;
				},
			},
		},

		props: {
			readonly: {
				default: false
			},

			actions: Array,

			administrative: Array,

			fundings: Array,

			mutual: Boolean,

			biddersChanged: Boolean,

			numberOfModules: {
				default: 0
			},
			moduleNumber: {
				default: ''
			},
			showPrintInfo: {
				type: Boolean, default: false
			}

		},

		mounted() {
			if (this.biddersChanged) {
				this.$emit("reloadFundings");
			}
		},

	};
</script>

<style scoped>

</style>
